import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

const StyledMovingRow = styled.div`
  pointer-events: none;
  display: inline-block;
  position: relative;
  width: 100%;
  z-index: 1000;
  /* margin-top: 299px; */
`
const RowImage = styled.img<{ switchduration: number }>`
  height: 100%;
  position: absolute;
  bottom: 0;
  transition: ${({ switchduration }) =>
    'left ' + switchduration * 0.4 + 's ease-in-out .3s'};
`

export const MovingRow = ({
  imagefile,
  direction = 'right',
  elementsOnScreen = 7,
  elementInImage = 25,
  imagewidth = 5625,
  imageheight = 300,
  switchduration = 3,
  elementSpaceInImage = 15
}: {
  imagefile: string
  direction: string
  elementsOnScreen?: number
  elementInImage?: number
  imagewidth?: number
  imageheight?: number
  switchduration?: number
  elementSpaceInImage?: number
}) => {
  const elementImageWidth = imagewidth / elementInImage
  const [elementScreenWidth, setElementScreenWidth] = useState(
    window.innerWidth / elementsOnScreen
  )

  const [scale, setScale] = useState(elementScreenWidth / elementImageWidth)
  const [currentPos, setCurrentPos] = useState(
    direction === 'right'
      ? [elementsOnScreen, elementsOnScreen - elementInImage]
      : [0, elementInImage]
  )

  const img = require('images/' + imagefile)
  const rowimage = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const handleWindowResize = () => {
      setElementScreenWidth(window.innerWidth / elementsOnScreen)
      setScale(window.innerWidth / elementsOnScreen / elementImageWidth)
      setCurrentPos(
        direction === 'right'
          ? [elementsOnScreen, elementsOnScreen - elementInImage]
          : [0, elementInImage]
      )
    }
    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      switch (direction) {
        case 'right':
          setCurrentPos(prevpos => {
            return [
              prevpos[0] + 1 > elementInImage - elementsOnScreen
                ? prevpos[1] - elementInImage + 1
                : prevpos[0] + 1,
              prevpos[1] + 1 > elementInImage - elementsOnScreen
                ? prevpos[0] - elementInImage + 1
                : prevpos[1] + 1
            ]
          })
          break
        case 'left':
          setCurrentPos(prevpos => {
            return [
              prevpos[0] - 1 < -elementInImage
                ? prevpos[1] + elementInImage - 1
                : prevpos[0] - 1,
              prevpos[1] - 1 < -elementInImage
                ? prevpos[0] + elementInImage - 1
                : prevpos[1] - 1
            ]
          })
          break
      }
    }, switchduration * 1000)
    return () => clearInterval(interval)
  }, [])

  return (
    <StyledMovingRow
      style={{
        height: elementScreenWidth - elementSpaceInImage * scale + 'px',
        marginBottom: elementSpaceInImage * scale + 'px'
      }}
    >
      <RowImage
        switchduration={switchduration}
        ref={rowimage}
        src={img}
        style={{
          left:
            currentPos[0] * elementScreenWidth +
            (elementSpaceInImage / 2) * scale +
            'px',
          height: imageheight * scale,
          opacity:
            currentPos[0] > elementInImage
              ? 0
              : currentPos[0] > -elementInImage
              ? 1
              : 0
        }}
      />
      <RowImage
        switchduration={switchduration}
        ref={rowimage}
        src={img}
        style={{
          left:
            currentPos[1] * elementScreenWidth +
            (elementSpaceInImage / 2) * scale +
            'px',
          height: imageheight * scale,
          opacity:
            currentPos[1] > elementInImage
              ? 0
              : currentPos[1] > -elementInImage
              ? 1
              : 0
        }}
      />
    </StyledMovingRow>
  )
}
